import React from "react";
import "../../Css/Home/Home.css";

const Home = () => {
  return (
    <div className="home">
      <div className="head">Hey there!</div>
      <div className="desc">
        I am Aayush Mainali from Nepal, A web developer who loves doing random things on the web. I have developed a few things here and there on the web. Not that good of a
        designer but I try my best! I mostly use MERN stack with Typescript and React Native for most of my projects.
      </div>
    </div>
  );
};

export default Home;
